import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import ReactPaginate from "react-paginate";

const PaginationButtons = ({ setCurrentPage, currentPage, totalPages }: any) => {
  const handlePageClick = ({ selected }: any) => {
    setCurrentPage(selected);
  };

  const showNextButton = currentPage < totalPages - 1;
  const showPrevButton = currentPage > 0;

  return (

    <ReactPaginate
      breakLabel={<span className="m-4">...</span>}
      nextLabel={
        showNextButton ? (
          <span className="w-7 h-7 flex items-center justify-center bg-lightGray rounded-md">
            <BsChevronRight />
          </span>
        ) : null
      }
      onPageChange={handlePageClick}
      pageRangeDisplayed={3}
      pageCount={totalPages}
      previousLabel={
        showPrevButton ? (
          <span className="w-7 h-7 flex items-center justify-center bg-lightGray rounded-md ">
            <BsChevronLeft />
          </span>
        ) : null
      }
      containerClassName="flex items-center justify-center mt-1 "
      pageClassName="block w-7 h-7 rounded-md flex items-center justify-center text-xs"
      activeClassName="bg-primary text-white text-sm"
      pageLinkClassName="p-2"
      forcePage={currentPage}
    />
  );
};

export default PaginationButtons;
